import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { Location } from '@angular/common';

@Component({
  selector: 'app-notfound',
  standalone: true,
  imports: [RouterModule, ButtonModule],
  template: `
    <div class="flex items-center justify-center min-h-[80dvh] overflow-hidden">
      <div class="flex flex-col items-center justify-center">
        <div
          class="w-full bg-surface-0 dark:bg-surface-900 py-20 px-8 sm:px-20 flex flex-col items-center"
          style="border-radius: 53px; box-shadow: 0 0 10px 0 var(--primary-color);"
        >
          <span class="text-primary font-bold text-3xl">404</span>
          <h1 class="text-surface-900 dark:text-surface-0 font-bold text-3xl mb-2">No encontrado</h1>
          <div class="text-surface-600 dark:text-surface-200 mb-8">
            No hay contenido asociado a la ruta
            <b class="text-surface-900 dark:text-surface-0">{{ url }}</b>
          </div>
          <a
            (click)="back()"
            style="cursor: pointer;"
            class="w-full flex items-center py-8 border-surface-300 dark:border-surface-500 border-b"
          >
            <span
              class="flex justify-center items-center border-2 border-primary text-primary rounded-border"
              style="height: 3.5rem; width: 3.5rem"
            >
              <i class="pi pi-fw pi-arrow-left !text-2xl"></i>
            </span>
            <span class="ml-6 flex flex-col">
              <span class="text-surface-900 dark:text-surface-0 lg:text-xl font-medium mb-0 block">
                Volver a la pagina anterior
              </span>
            </span>
          </a>
          <br>
          <p-button label="Ir al Inicio" icon="pi pi-home" class="mt-0" routerLink="/" />
        </div>
      </div>
    </div>
  `
})
export class Notfound implements OnInit {
  private readonly actRoute = inject(ActivatedRoute);
  private readonly location = inject(Location);
  private readonly router = inject(Router);
  public url!: string;

  ngOnInit(): void {

    this.url =
      !!sessionStorage.getItem('last_url') && sessionStorage.getItem('last_url') !== ''
        ? sessionStorage.getItem('last_url')
        : '/';
    console.log('last_url', this.url);
  }

  back() {
    this.router.navigateByUrl(this.url || '/');
  }
}
